var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-step"},[(_vm.registerOK)?_c('div',[_c('div',{class:_vm.animationclass,staticStyle:{"justify-content":"center"},attrs:{"id":"exito"}},[_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(
            _vm.getText(
              'register.step4.text1',
              'Perfecto, el registro ha terminado'
            )
          )}}),_c('div',{staticStyle:{"text-align":"center","margin-top":"30%"},attrs:{"id":"loader-container"}},[_c('Loader')],1),_c('p',[_c('a',{domProps:{"innerHTML":_vm._s(
              _vm.getText(
                'register.step4.text2',
                'Te redirigimos a la página principal'
              )
            )},on:{"click":_vm.gotoNextPage}})])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }